/**
 * Zařízení — samostatné menu a hub (Registr / Převodky / Produkty / Kalendář).
 * When `false`, `/equipment` redirects to Materiály › Zásoby and legacy `/materials/equipment/*` stay on Spotřební.
 */
export const EQUIPMENT_HUB_UI_ENABLED = true;
